import FilterUtils from '@/shared/utils/filters';

export default class FeeItemRuleRequest {
  id: string;

  fee: number | string;

  feeType: string;

  applyFee: boolean;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.fee = FilterUtils.formatValue(obj.fee) || 0;
    this.feeType = obj.feeType || '';
    this.applyFee = obj.applyFee || false;
  }

  public static of(obj: any = {}): FeeItemRuleRequest {
    return new FeeItemRuleRequest(obj || {});
  }

  public static ofList(obj: any[]): FeeItemRuleRequest[] {
    return obj.map(this.of);
  }
}
